export const DEFAULT = "DEFAULT";
export const BANK_TRANSFER = "bank-transfer";
export const C2P = "2C2P";
export const CASH = "cash";

export const PAYMENT_STATUS = {
    PENDING: "PENDING",
    PENDING_CONFIRM: "PENDING_PAYMENT_CONFIRMATION",
    REJECTED: "REJECTED",
    CONFIRMED: "CONFIRMED",
};

export const PAYMENT_STATUSES = [
    {
        id: PAYMENT_STATUS.PENDING,
        label: "paymentPending",
        color: "#FAC256",
    },
    {
        id: PAYMENT_STATUS.PENDING_CONFIRM,
        label: "paymentPendingConfirm",
        color: "#84C4FF",
    },
    {
        id: PAYMENT_STATUS.REJECTED,
        label: "rejected",
        color: "#FF1100",
    },
    {
        id: PAYMENT_STATUS.CONFIRMED,
        label: "confirmed",
        color: "#33B950",
    },
];

export enum PaymentMethod {
    DEFAULT = "DEFAULT",
    PAYMENT_2C2P = "PAYMENT_2C2P",
    BANK_TRANSFER = "BANK_TRANSFER",
    CREDIT_CARD = "CREDIT_CARD",
    CREDIT_CARD_POS = "CREDIT_CARD_POS",
    EMPLOYEE_SALARY_DEDUCTION = "EMPLOYEE_SALARY_DEDUCTION",
    PAID_BY_CHECK = "PAID_BY_CHECK",
    CASH = "CASH",
    THAI_QR_PAYMENT = "THAI_QR_PAYMENT",
}

export enum SourceOfPayment {
    QUOTATION = "QUOTATION",
    ORDER = "ORDER",
}
